import Dashboard from "@/pages/Dashboard";
import EvaluationForm from "@/pages/EvaluationForm";
import PlayersPage from "@/pages/PlayersPage";
import ComparePage from "@/pages/ComparePage";
import EvaluatorsPage from "@/pages/EvaluatorsPage";
import TeamsPage from "@/pages/TeamsPage";
import TeamsComparePage from "@/pages/TeamsComparePage";
import PlayerHistoryPage from "@/pages/PlayerHistoryPage";
import GameDayPage from "@/pages/GameDayPage";
import StatisticsPage from "@/pages/StatisticsPage";
import CalendarPage from "@/pages/CalendarPage";
import AttendancePage from "@/pages/AttendancePage";
import PaymentsPage from "@/pages/PaymentsPage";
import PermissionsPage from "@/pages/PermissionsPage";
import RolePermissionsPage from "@/pages/RolePermissionsPage";
import PasswordManagementPage from "@/pages/PasswordManagementPage";
import InvitesPage from "@/pages/InvitesPage";
import WeeklyReportPage from "@/pages/WeeklyReportPage";
import InvitePlayersPage from "@/pages/InvitePlayersPage";
import EvaluationsPanel from "@/pages/EvaluationsPanel";
import RankingPage from "@/pages/RankingPage";
import GameRegistrationsPage from "@/pages/GameRegistrationsPage";
import GamePlayersPage from "@/pages/GamePlayersPage";
import PlayerReportPage from "@/pages/PlayerReportPage";
import AdminProfilePage from "@/pages/AdminProfilePage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";

// Access levels for route protection
// "auth" = any logged-in user
// "evaluator" = logged-in but NOT player
// "roles" = specific roles required
// "admin" = admin only
// "player" = player only
export const routeConfig = [
  { path: "/dashboard", component: Dashboard, access: "evaluator", passLogout: true },
  { path: "/evaluate", component: EvaluationForm, access: "evaluator", passLogout: true },
  { path: "/players", component: PlayersPage, access: "evaluator", passLogout: true },
  { path: "/players/:playerId/history", component: PlayerHistoryPage, access: "auth" },
  { path: "/compare", component: ComparePage, access: "evaluator", passLogout: true },
  { path: "/evaluators", component: EvaluatorsPage, access: "roles", roles: ["admin", "tecnico"], passLogout: true },
  { path: "/teams", component: TeamsPage, access: "roles", roles: ["admin", "tecnico"], passLogout: true },
  { path: "/teams/compare", component: TeamsComparePage, access: "roles", roles: ["admin", "tecnico"] },
  { path: "/gameday", component: GameDayPage, access: "roles", roles: ["admin", "tecnico"] },
  { path: "/game-registrations", component: GameRegistrationsPage, access: "roles", roles: ["admin", "tecnico"] },
  { path: "/game-players", component: GamePlayersPage, access: "auth" },
  { path: "/statistics", component: StatisticsPage, access: "auth" },
  { path: "/calendar", component: CalendarPage, access: "auth" },
  { path: "/attendance", component: AttendancePage, access: "auth" },
  { path: "/payments", component: PaymentsPage, access: "roles", roles: ["admin", "tecnico"] },
  { path: "/permissions", component: PermissionsPage, access: "evaluator" },
  { path: "/role-permissions", component: RolePermissionsPage, access: "admin", passLogout: true },
  { path: "/password-management", component: PasswordManagementPage, access: "admin", passLogout: true },
  { path: "/invites", component: InvitesPage, access: "auth" },
  { path: "/weekly-report", component: WeeklyReportPage, access: "evaluator" },
  { path: "/invite-players", component: InvitePlayersPage, access: "evaluator" },
  { path: "/evaluations", component: EvaluationsPanel, access: "auth", passLogout: true },
  { path: "/ranking", component: RankingPage, access: "auth" },
  { path: "/player-report", component: PlayerReportPage, access: "evaluator" },
  { path: "/change-password", component: ChangePasswordPage, access: "auth", passLogout: true },
];
